import React from 'react';

import GenericField from './shared/GenericField';
import ItemInputContainer from './item/ItemInputContainer';

/**
 * Select single item from dropdown. Requets suggestions given user input. "item" object: {string id, string name, string detailedName, string link}. detailedName is optional and then used instead of name inin the dropdown.
 * @param {string} [label] Label description for field input.
 * @param {string} [icon] Icon next to input, see ./shared/FormatHelpers.js/getIconClassName for available icons.
 * @param {item} [initialValue] Field value.
 * @param {function} [handleSave] [async item=>{bool success, string message, item value}] Save changes / return error message. If item.id = null then this object should be created with item.id and item.link from item.name and returned as value.
 * @param {function} [getSuggestions] [async string=>list<item>] Gets suggestions corresponding to user input.
 * @param {bool} [isCreationPermitted] Whether the user can create a new object. See handleSave for how items should be created.
 */
const Item = ({ label, icon: iconName, initialValue, handleSave: syncChanges, getSuggestions, isCreationPermitted }) => {
    return (
        <GenericField>
            {label}
            <ItemInputContainer {...{ iconName, initialValue, syncChanges, getSuggestions, isCreationPermitted }} />
        </GenericField>
    );
};

export default Item;
